export const CONFIG = {
    totalPairs: 20,
    totalTime: 150,
    judgeDelay: 800,
    matchDelay: 350,
    matchEffectDuration: 800,
    resultDelay: 500,
    countdown: [
        { phase: "ready", text: "よーい", image: "txt_ready_1.svg", duration: 1300 },
        { phase: "start", text: "始め！", image: "txt_ready_2.svg", duration: 600 },
    ],
    imageDirectory: "/assets/img/special/shinkeisuijaku/game/card/",
    effectImageDirectory: "/assets/img/special/shinkeisuijaku/game/",
    shareHashtags: "#ツガイ神経衰弱 #黄泉のツガイ",
    shareUrl: "https://yominotsugai.com/special/shinkeisuijaku/",
};

export const SELECTOR = {
    root: ".js-shinkeisuijaku",
    screen: "[data-shinkeisuijaku-screen]",
    board: ".js-shinkeisuijaku-board",
    start: ".js-shinkeisuijaku-start",
    timer: ".js-shinkeisuijaku-timer",
    matchedCount: ".js-shinkeisuijaku-matched-count",
    totalCount: ".js-shinkeisuijaku-total-count",
    countdown: ".js-shinkeisuijaku-countdown",
    countdownText: ".js-shinkeisuijaku-countdown-text",
    matchEffect: ".js-shinkeisuijaku-match-effect",
    result: ".js-shinkeisuijaku-result",
    resultHeading: ".js-shinkeisuijaku-result-heading",
    resultPairs: ".js-shinkeisuijaku-result-pairs",
    resultTime: ".js-shinkeisuijaku-result-time",
    share: ".js-shinkeisuijaku-share",
    card: ".js-shinkeisuijaku-card",
};
